import { useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import { Loader2, BedDouble } from "lucide-react";

export const HkMissingRoomsToggle = ({ enabled, canEdit, onChange }) => {
  const [busy, setBusy] = useState(false);
  const runNow = async () => {
    setBusy(true);
    try {
      const r = await api.post("/housekeeping/run-missing-rooms-alert", null, { params: { force: true } });
      if (!r.data.mail_configured) toast.error("Email isn't configured here — alerts will email once Resend is set up in production.");
      else if (r.data.emails_sent > 0) toast.success(`Sent ${r.data.emails_sent} missing-rooms email(s)`);
      else toast.message("Nothing to send — yesterday's housekeepers all have rooms entered.");
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <div className="space-y-3 rounded-lg border border-border p-4 md:col-span-2" data-testid="detail-hk-missing-rooms-section">
      <div className="flex items-center justify-between">
        <div>
          <Label className="text-sm font-bold">Missed Rooms alert</Label>
          <p className="text-xs text-muted-foreground">Every morning at <b>9 AM</b> (property local time), email this property's GMs if yesterday has housekeeping hours but 0 rooms entered.</p>
        </div>
        <Switch checked={!!enabled} disabled={!canEdit} onCheckedChange={onChange} data-testid="detail-hk-missing-rooms-enabled" />
      </div>
      {enabled && (
        <div className="border-t border-border pt-3">
          <Button variant="outline" size="sm" onClick={runNow} disabled={busy} data-testid="detail-hk-missing-rooms-run">
            {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <BedDouble className="mr-2 h-4 w-4" />} Check &amp; send now
          </Button>
          <p className="mt-1 text-xs text-muted-foreground">Save your changes first. Sends for every property with this alert on.</p>
        </div>
      )}
    </div>
  );
};
